export default {
    LOGIN_ENDPOINT: '/sso/login?auth_driver=b2c',
    LOGOUT_ENDPOINT: '/logout?auth_driver=b2c',
};
